import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { PAGES } from '../../constants/pages';
import {
  APPLICATION_TYPE_INDIVIDUAL,
  APPLICATION_TYPE_JOINT_TENANTS,
  APPLICATION_TYPE_CORPORATE,
  ACCOUNT_TYPE_CORPORATE_TRUST,
} from '../../constants/accountTypes';
import SelectList from '../../components/SelectList/SelectList';
import BaseLayout from '../../components/BaseLayout';
import { Heading } from '../../components/Heading';
import { applicationTypeSetupSuccess } from '../../store/actions/application/applicationActions';
import { selectSettings } from '../../store/selectors/settingsSelectors';

const CreateApplicationStandard = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { BrokerName } = useSelector(selectSettings);

  const options = [
    {
      title: t('selectPath.options.standard.owner.me'),
      onClick: () => {
        dispatch(
          applicationTypeSetupSuccess({
            ApplicationType: APPLICATION_TYPE_INDIVIDUAL,
          }),
        );
        history.push(PAGES.CREATE_ACCOUNT);
      },
    },
    {
      title: t('selectPath.options.standard.owner.joint'),
      onClick: () => {
        dispatch(
          applicationTypeSetupSuccess({
            ApplicationType: APPLICATION_TYPE_JOINT_TENANTS,
          }),
        );

        history.push(PAGES.CREATE_ACCOUNT);
      },
    },
    {
      title: t('selectPath.options.standard.owner.trust'),
      onClick: () => {
        dispatch(
          applicationTypeSetupSuccess({
            ApplicationType: APPLICATION_TYPE_CORPORATE,
            AccountType: ACCOUNT_TYPE_CORPORATE_TRUST,
          }),
        );

        history.push(PAGES.CREATE_ACCOUNT);
      },
    },
    {
      title: t('selectPath.options.standard.owner.business'),
      onClick: () => {
        dispatch(
          applicationTypeSetupSuccess({
            ApplicationType: APPLICATION_TYPE_CORPORATE,
          }),
        );

        history.push(PAGES.CREATE_ACCOUNT);
      },
      showDivider: false,
    },
  ];

  return (
    <BaseLayout
      canShowEmail={false}
      previousPath={PAGES.CREATE_APPLICATION.MAIN}
    >
      <Helmet>
        <title>
          {t('selectPath.options.standard.titleTag', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <Heading mb={28}>{t('selectPath.options.standard.owner.title')}</Heading>
      <SelectList options={options} />
    </BaseLayout>
  );
};

export default CreateApplicationStandard;
